import React from "react";
import moment from "moment";
import format from "date-fns/format";
import axios from "axios";
import { hostServer } from "../actions/consts/host";
import { connect } from "react-redux";
import * as R from "ramda";
import RoundChart from "./RoundChart";
import "../styles/components/check-detail.scss";

class PublicStatus extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      monitor: undefined,
      data: undefined,
      downtimeData: undefined,
      apdexData: undefined,
      rawData: undefined,
    };
  }

  downtimeData = (downtimeRawData, date) => {
    let i;
    const finalArr = [];
    if (!R.isEmpty(downtimeRawData)) {
      const firstOfDay = moment(downtimeRawData[0].from_time)
        .utc()
        .startOf("day");
      const endOfDay = moment(downtimeRawData[0].from_time).utc().endOf("day");
      for (i = 0; i < downtimeRawData.length; i++) {
        const fromTime = moment(downtimeRawData[i].from_time);
        const toTime = moment(downtimeRawData[i].to_time);

        if (i === 0) {
          const duration = moment
            .duration(fromTime.diff(firstOfDay))
            .as("seconds");
          if (duration) {
            finalArr.push({
              from_time: firstOfDay.utc().format(),
              to_time: fromTime.utc().format(),
              status: "up",
              duration,
            });
          }
        }
        finalArr.push({
          ...downtimeRawData[i],
          status: "down",
          duration: moment.duration(toTime.diff(fromTime)).as("seconds"),
        });

        if (i !== downtimeRawData.length - 1) {
          const fromTimeNext = moment(downtimeRawData[i + 1].from_time);

          const duration = moment
            .duration(fromTimeNext.diff(toTime))
            .as("seconds");
          if (duration) {
            finalArr.push({
              from_time: toTime.utc().format(),
              to_time: fromTimeNext.utc().format(),
              status: "up",
              duration,
            });
          }
        } else {
          const duration = moment.duration(toTime.diff(endOfDay)).as("seconds");
          if (duration) {
            finalArr.push({
              from_time: toTime.utc().format(),
              to_time: endOfDay.utc().format(),
              status: "up",
              duration,
            });
          }
        }
      }
    } else {
      const firstOfDay = moment(date).utc().startOf("day");
      const endOfDay = moment(date).utc().endOf("day");
      const duration = moment.duration(endOfDay.diff(firstOfDay)).as("seconds");
      finalArr.push({
        from_time: firstOfDay.utc().format(),
        to_time: endOfDay.utc().format(),
        status: "up",
        duration,
      });
    }

    return finalArr;
  };

  async componentDidMount() {
    if (this.props.token) {
      const id = this.props.match.params.id;
      const token = this.props.token;
      const date = moment(moment().subtract(2, "days").format("YYYY-MM-DD"));
      const tommorowDate = moment().subtract(1, "days").format("YYYY-MM-DD");

      const json = {
        headers: {
          Authorization: `Token ${token}`,
        },
      };

      const res = await axios.get(`${hostServer}/api/v1/monitors/${id}/`, json);
      const monitor = res.data;
      const isHttp = monitor.protocol_type === "HTTP(S)";
      const target = isHttp ? monitor.url : monitor.host;
      const name = monitor.alias
        ? `${monitor.protocol_type}:${monitor.alias}`
        : target;
      const status = res.data
        ? isHttp
          ? res.data.last_status_code
          : res.data.last_status
        : null;

      const day = format(new Date(date), "yyyy-MM-d");

      const { data } = await axios.get(
        `${hostServer}/api/v1/monitors/${id}/metric?day=${day}`,
        json
      );

      const apdexData = data.last_day_hourly_metrics.apdex_percents.map(
        (el, i) => ({ value: parseFloat(el, 10), duration: 1, time: i })
      );
      const downtimeData = this.downtimeData(data.downtimes, date.format());

      const formatedDate = date.format("YYYY-MM-DD");

      const rawData1 = await axios.get(
        `https://api.updamus.com/api/v1/monitors/${id}/metric/raw?from_time=${formatedDate}%2000:00:00.00&to_time=${formatedDate}%2006:00:00.00`,
        json
      );

      const rawData2 = await axios.get(
        `https://api.updamus.com/api/v1/monitors/${id}/metric/raw?from_time=${formatedDate}%2006:00:00.00&to_time=${formatedDate}%2012:00:00.00`,
        json
      );

      const rawData3 = await axios.get(
        `https://api.updamus.com/api/v1/monitors/${id}/metric/raw?from_time=${formatedDate}%2012:00:00.00&to_time=${formatedDate}%2018:00:00.00`,
        json
      );

      const rawData4 = await axios.get(
        `https://api.updamus.com/api/v1/monitors/${id}/metric/raw?from_time=${formatedDate}%2018:00:00.00&to_time=${tommorowDate}%2000:00:00.00`,
        json
      );

      const rawDataUnProcessed = R.reduce(
        R.concat,
        [],
        [
          rawData1.data.result,
          rawData2.data.result,
          rawData3.data.result,
          rawData4.data.result,
        ]
      );

      const rawDataRaw = rawDataUnProcessed.sort(
        (a, b) => new Date(a.time) - new Date(b.time)
      );

      const rawData = rawDataRaw.filter((el) => el.probe_success === 1);

      this.setState((state) => ({
        monitor: { ...monitor, target, name, status, isHttp },
        data,
        downtimeData,
        apdexData,
        rawData,
      }));
    }
  }

  render() {
    return (
      <div className="route-container">
        <div className="page">
          <div className="check-detail__container">
            {this.state.monitor && (
              <div className="check-detail__left">
                {/* <MonitorHeader
                  data={{ ...this.state.monitor, data: this.state.data }}
                  isShare={true}
                /> */}
                <RoundChart
                  background="#21242e"
                  chartBgColor="#21242e"
                  rtLineColor="#35b2fb"
                  annotateColor="#eaf6f6"
                  downtimeData={this.state.downtimeData}
                  apdexData={this.state.apdexData}
                  rawData={this.state.rawData}
                  monitorName={this.state.monitor.name}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    token: state.auth.uid,
  };
};

// const mapDispatchToProps = (dispatch) => ({
//   startGetMonitorHistory: (id, date) =>
//     dispatch(startGetMonitorHistory(id, date)),
//   startRefresh: (id, isRefresh) => dispatch(startRefresh(id, isRefresh)),
// });

export default connect(mapStateToProps)(PublicStatus);
